import { Controller } from "stimulus"
import Quill from '../lib/quill';

export default class extends Controller {
  get richest() {
    return this.element.hasAttribute('data-attributes-richest');
  }

  get richer() {
    return this.element.hasAttribute('data-attributes-richer');
  }

  connect() {
    let options = [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link']
    ];

    let richest_options = [
      ['blockquote', 'code-block'],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'size': [] }],
    ];

    let richer_options = [
      [{ 'align': [] }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'header': 1 }, { 'header': 2 }],
    ];

    if (this.richer) {
      options = options.concat(richer_options);
    }

    if (this.richest) {
      options = options.concat(richer_options).concat(richest_options);
    }

    this.editor = new Quill(this.element, 
      {
        modules:  { 
          toolbar: options
        },
        theme: 'snow'
      }
    );

    this.editor.on('selection-change', (range, oldRange, source) => {
      if (range) {
        this.editor.container.setAttribute('focus', '');
        toolbar = this.editor.container.previousSibling
        toolbar.setAttribute('focus', '');
      } else {
        this.editor.container.removeAttribute('focus', '');
        toolbar = this.editor.container.previousSibling
        toolbar.removeAttribute('focus', '');
      } 
    });

    let dataset = this.element.dataset;
    if (dataset.for) {
      this.label = document.querySelector('label[data-for="' + dataset.for + '"]');
      this.label.addEventListener('click', (e) => {
        this.editor.focus();
      });
    }

    if (dataset.name) {
      this.hiddenInput = document.createElement('input');
      this.hiddenInput.name = dataset.name;
      this.hiddenInput.classList.add('-z-10', 'mx-2', 'w-full', 'opacity-0', 'inset-0');

      if (this.required) {
        this.hiddenInput.required = true;
      }

      this.hiddenInput.addEventListener('focus', this.hiddenInputFocus.bind(this));

      this.element.appendChild(this.hiddenInput);
      this.editor.on('text-change', this.editorTextChange.bind(this));
      this.editorTextChange();
    }

    if (this.required) {
      this.editor.root.addEventListener('blur', this.validate.bind(this));
      this.setupValidation();
    }
  }

  
  // Could be common functions moved into base class
  get form() {
    return this.element.closest('form');
  }

  get required() {
    return this.element.hasAttribute('data-required') && this.element.getAttribute('data-required') === 'true';
  }

  hiddenInputFocus(event) {
    event.preventDefault();
    event.target.blur();
    this.editor.focus();
  }

  editorTextChange() {
    this.hiddenInput.value = this.editor.root.innerHTML;
  }

  setupValidation() {
    if(this.form) {
      this.form.addEventListener('submit', this.validate.bind(this))
    }
    this.element.validCheck = this.validate.bind(this);
  }

  validate() {
    if(this.required) {
      if (this.editor.root.innerHTML == "<p><br></p>") {
        this.setErrorState();
        return false;
      } else {
        this.removeErrorState();
        return true;
      }
    }
  }
  setErrorState() {
    let _fieldWrapper = this.editor.root.closest('.sa-field-input-wrapper');

    _fieldWrapper.querySelector('.ql-toolbar').setAttribute('error', true);
    _fieldWrapper.querySelector('.ql-container').setAttribute('error', true);
  }
  removeErrorState() {
    let _fieldWrapper = this.editor.root.closest('.sa-field-input-wrapper');

    _fieldWrapper.querySelector('.ql-toolbar').removeAttribute('error');
    _fieldWrapper.querySelector('.ql-container').removeAttribute('error');
  }
}

